import { StartType } from '@wix/ambassador-pricing-plans-v3-plan/types';

/**
 * @returns true if the plan allows future start date, false otherwise.
 */

export const allowsFutureStartDateV3 = plan => {
  const pricingVariant = plan.pricingVariants?.[0];
  if (!pricingVariant) {
    return false;
  }
  const startType = pricingVariant.billingTerms?.startType;
  if (startType === StartType.CUSTOM) {
    return true;
  }
  return false;
};
//# sourceMappingURL=allows-future-start-date-v3.js.map